/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { NavLink } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import "./css/Navigation.css";

function Navigation() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top navbar">
      <div className="container-fluid">
        <HashLink className="navbar-brand" to="#top">
          <span className="navbar-brand" id="header-name-static" href="Innominate">Innominate <br /> <span
            id="header-tag">An Independent Monthly Newsletter</span></span>
        </HashLink>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
          aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink to="/home">
                <span className="nav-link active" aria-current="page" href="/home">Home</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <HashLink smooth to="/home#about-us-home">
                <span className="nav-link" id="about-link" href="/home#about-us-home">About Us</span>
              </HashLink>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                More
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                <li>
                  <HashLink to="/home#all-editions">
                    <span className="dropdown-item" href="All Our Issues Here!">All Issues</span>
                  </HashLink>
                </li>
                <hr className="dropdown-divider" />
                <li />
                <li>
                  <NavLink to="/editions/latest-issue">
                    <span className="dropdown-item" id="latest-issue-home" href="Latest Issue">Latest Issue</span>
                  </NavLink>
                </li>
                <li><a className="dropdown-item" href="https://fliphtml5.com/bookcase/mqshn" target="_blank" rel="noreferrer">Previous
                  Issues</a></li>
              </ul>
            </li>
            <li className="nav-item">
              <a className="nav-link" id="contact-link" href="https://www.getrevue.co/profile/innominate_news" target="_blank" rel="noreferrer">Sign Up Here!</a>
            </li>
            <HashLink smooth to="#contact-us">
              <li className="nav-item">
                <span className="nav-link" id="contact-link">Contact Us</span>
              </li>
            </HashLink>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;